import usePrevious from "./usePrevious";

// True on the render where a request this mounted screen saw running has
// just been answered (requesting went from true to false).
//
// The whole store is persisted to localStorage (store/configureStore.js), so
// a slice can already hold a settled action, for example "update" with
// requesting false, when a screen mounts: that is a save made earlier, not
// one made on this screen. A screen that goes back to its list after a save
// checks this as well as the action, or opening a record right after a save
// sends the admin straight back to the list (F-BUG-12).
const useRequestFinished = (requesting) => {
  const wasRequesting = usePrevious(requesting);
  return Boolean(wasRequesting) && !requesting;
};

export default useRequestFinished;
